module.exports = __webpack_public_path__ + "static/img/jcb.2739fb3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/payment-partner/jcb.png
// module id = 1ZV6
// module chunks = 1